import {Shower} from "../../parts/shower";
import {IntermediatePart} from "../../intermediatePart";
import {ShowerComboTubType, SIDE_POSITIONS} from "../../constants";
import {ShowerTubCombo} from "../../parts/showerTubCombo";

export default class AccessoryCommon extends IntermediatePart {

  constructor(props) {
    super(props);
  }

  getArrayOfConditions() {
    let conditions = super.getArrayOfConditions(); //roomLayout
    const layout = this.getParent().layout;
    const showerParent = layout.parts[Shower.id];
    const showerSize = showerParent.showerSize();
    if (showerParent && showerSize) {
      conditions.push({
        propName: "ShowerSize",
        propValue: showerSize
      });
    }
    if (this.partId === "grab_bar") {
      const showerCondition = showerParent.showerTubComboIsActive() && layout.parts[ShowerTubCombo.id]
      && (layout.parts[ShowerTubCombo.id].bottomTub === ShowerComboTubType.walk_in_tub)
        ? "Tub"
        : "Shower";
      conditions.push({
        propName: "Shower",
        propValue: showerCondition
      });
    }
    return conditions
  }

  checkRelatedFeatureGroupPositions(position) {
    const accessoriesParent = this.getParent();
    const showerParent = accessoriesParent.layout.parts[Shower.id]; // no need for another check
    const showerSize = showerParent.showerSize();
    let otherFeatureGroup = null;
    switch (this.partId) {
      case "grab_bar":
        otherFeatureGroup = accessoriesParent.soapDish;
        break;
      case "soap_dish":
        otherFeatureGroup = accessoriesParent.grabBar;
        break;
      case "shower_seats":
        otherFeatureGroup = accessoriesParent.largeCornerSeat;
        break;
      case "large_corner_seat":
        otherFeatureGroup = accessoriesParent.seats;
        break;
      default:
        break;
    }
    if (showerSize === "30") {
      if (otherFeatureGroup && otherFeatureGroup.layerPositions && !this.disabled && Object.keys(this.layerPositions).some(key => this.layerPositions[key])) {
        Object.keys(otherFeatureGroup.layerPositions).forEach(key => {
          otherFeatureGroup.layerPositions[key] = null
        });
      }
      if (this.layerPositions) {
        Object.keys(this.layerPositions).forEach(key => {
          if (key !== position) {
            this.layerPositions[key] = null; // it can be only on one side on small shower size
          }
        })
      }
    } else {
      if (this.layerPositions[position] && otherFeatureGroup && otherFeatureGroup.layerPositions[position] && !otherFeatureGroup.disabled) {
        const newPosition = position === SIDE_POSITIONS[0] ? SIDE_POSITIONS[1] : SIDE_POSITIONS[0];
        if (!this.layerPositions[newPosition]) {
          const matchingPositionFeature = otherFeatureGroup.getMatchingPositionFeature(newPosition, otherFeatureGroup.layerPositions[position]);
          if (matchingPositionFeature) {
            otherFeatureGroup.layerPositions[newPosition] = matchingPositionFeature;
          }
        }
        otherFeatureGroup.layerPositions[position] = null; //2) remove old soap dish position
      }
    }
  }

}
